<template>
  <div class="view view-curso">
    <top-bar v-if="isPortalReady" />

    <div class="anuncio-wrapper"
        v-if="estado_compra=='PAGADA' || estado_compra=='PAGADA_SUSCRITO'">
        <div class="d-flex">
            <div class="anuncio-image">
                <img :src="require('@/assets/images/logogris.svg')" alt="">
            </div>
            <div class="d-flex align-items-center anuncio-contenido anuncio-contenido-encima">
                <div class="container">
                    <h1 class="anuncio-titulo">BIENVENID@</h1>
                    <h3 class="anuncio-subtitulo">Compra confirmada</h3>
                    <div class="checkout-curso-listo">Ya puedes ingresar a tu curso</div>

                    <p v-if =" this.$route.params.pasarela == 'preworklandingoperador' " >
                        <router-link :to="{name: 'home',
                                query: { sus: '0' },
                            }"
                            class="btn btn-primary">
                            Ir al curso
                        </router-link>
                    </p>

                    <p v-else>
                        <router-link :to="{name:'curso',
                                params: {
						            guid: linkCurso.guid
					            }
                            }"
                            class="btn btn-primary">
                            Ir al curso
                        </router-link>
                    </p>

                </div>
            </div>
        </div>
    </div>


    <div class="anuncio-wrapper"
        v-if="estado_compra=='PROCESANDO'">
        <div class="d-flex">
            <div class="anuncio-image">
                <img :src="require('@/assets/images/logogris.svg')" alt="">
            </div>
            <div class="d-flex align-items-center anuncio-contenido anuncio-contenido-encima">
                <div class="container">
                    <h1 class="anuncio-titulo">BIENVENID@</h1>
                    <h3 class="anuncio-subtitulo">Estamos confirmando tu compra </h3>
                    <div class="checkout-curso-listo">Dentro de poco podrás ingresar a tu curso</div>

                    <p v-if =" this.$route.params.pasarela == 'preworklandingoperador' " >
                        <router-link :to="{name: 'home',
                                query: { sus: '0' },
                            }"
                            class="btn btn-primary">
                            Ir al curso
                        </router-link>
                    </p>

                    <p v-else>
                        <router-link :to="{name:'curso',
                                params: {
						            guid: linkCurso.guid
					            }
                            }"
                            class="btn btn-primary">
                            Ir al curso
                        </router-link>
                    </p>

                </div>
            </div>
        </div>
    </div>

    <div class="anuncio-wrapper"
        v-if="estado_compra=='RECHAZADA' || estado_compra=='PENDIENTE_PAGO' || estado_compra=='ERROR'">
        <div class="d-flex">
            <div class="anuncio-image">
                <img :src="require('@/assets/images/excl.png')" alt="">
            </div>
            <div class="d-flex align-items-center anuncio-contenido anuncio-contenido-encima">
                <div class="container">
                    <h3 class="anuncio-sobretitulo">Ha ocurrido un error en tu compra</h3>
                    <h1 class="anuncio-titulo">Inténtalo nuevamente</h1>
                    <p>En caso de cualquier inconveniente con la compra de tu curso
                    puedes escribir a <a class="color-aqua" href="mailto:soporte@topclass.cl">soporte@topclass.cl</a></p>
                    <p>
                        <router-link :to="{name: 'home'}"
                            class="btn btn-primary">
                            Volver a comprar
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--
    <div class="container" v-if="estado_compra=='PAGADA' || estado_compra=='PAGADA_SUSCRITO'">
        <h3 class="curso-clases-title">{{user.name}} {{user.apellido}} tu compra {{compra.num_compra}} se encuentra {{compra.estado_compra}}</h3>
        <p>Ya puedes tener acceso al curso online de  {{curso}}  hasta {{fecha_vencimiento}}</p>
        <img :src="foto_principal" >

    </div>

    <div class="container" v-if="estado_compra=='RECHAZADA'">
        <h3 class="curso-clases-title">{{user.name}} {{user.apellido}} tu compra {{compra.num_compra}} se encuentra {{compra.estado_compra}}</h3>
        <p>Intentar de nuevo la compra <button class="btn " @click="VerificarCompra($route.params.id_compra)">Verificar compra</button></p>
        <img :src="foto_principal" >

    </div>
    -->
    <site-footer v-if="isPortalReady" :verFooter="true"/>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Carousel } from "bootstrap-vue/es/components";
import TopBar from "../components/TopBar";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import ContenidoList from "../components/ContenidoList";
import Spinner from "../components/Spinner";
import {
	getCategoriaDeProducto,
} from "../utilities/data";
Vue.use(Carousel);

export default {
	name: "CheckoutFinish",
	components: {
		TopBar,
		CursoList,
		SiteFooter,
		Spinner,
		ContenidoList
    },
    props: {
        productoLanding: {
            type: Object,
            default: null
        }
    },
	data() {
		return {
			isLoadingContenido: false,
			compra: [],
			estado_compra: null,
            curso: null,
            cursoId:null,
			fecha_vencimiento: null,
            foto_principal: null,
            linkCurso:null,
            montoTotal:0

		};
	},
	computed: {
        ...mapState(["portal", "user", "isPortalReady"]),


    },
	methods: {
		DetalleCompra() {
			let Data = {
                id_compra: this.$route.params.id_compra,
                id_user:(typeof this.$route.query.iduser !=='undefined') ? this.$route.query.iduser : "",
                email:(typeof this.$route.query.email !=='undefined') ? this.$route.query.email : "",
            };

            //TODO Rutina para compras por prework para cuando la compra no este disponible aun
            if(  this.$route.params.pasarela == "preworklandingoperador" && this.productoLanding != null ){

                this.estado_compra = "PROCESANDO";
                this.linkCurso = getCategoriaDeProducto(this.portal, this.productoLanding.id);

                //ACTIVAR COMPRA FINALIZADA
                dataLayer.push({
                    'event':"transaction",
                    'ecommerce': {
                        'purchase': {
                            'actionField': {
                                'id': Data.id_compra,              // Transaction ID. Required for purchases and refunds.
                                'affiliation': this.portal.nombre,
                                'revenue': 990,                    // Total transaction value (incl. tax and shipping)
                                'tax':'0',
                            },
                            'products': [{                         // List of productFieldObjects.
                                'name': this.productoLanding.producto, // Name or ID is required.
                                'id': this.productoLanding.id,
                                'price': 990,
                                'category': this.linkCurso.categoria,
                                'quantity': 1,
                            }]
                        }
                    }
                });
                
            }else{

                this.$api
                    .detalle_compra(Data)
                    .then(response => {
                        if (
                            typeof response.data.error !== "undefined" ||
                            response.data.data == "ERROR"
                        ) {
                            
                            console.log(response.data);
                            this.$router.push({
                                name: "error404"
                            });

                        }
                        console.log(response.data.data);
                        this.compra = response.data.data;
                        this.foto_principal =
                            response.data.data.detalles_compras.compras_productos[0].foto_principal;
                        this.fecha_vencimiento =
                            response.data.data.detalles_compras.compras_productos[0].fecha_fin;
                        this.curso =
                            response.data.data.detalles_compras.compras_productos[0].producto;
                        this.cursoId =
                            response.data.data.detalles_compras.compras_productos[0].id_producto;
                        this.estado_compra = response.data.data.estado_compra;

                        this.linkCurso=getCategoriaDeProducto(this.portal,this.cursoId);


                        this.montoTotal=this.compra.total;

                        if(this.compra.tipo_descuento=="porcentaje"){
                                this.montoTotal=response.data.data.detalles_compras.compras_productos[0].precio*(this.compra.monto_descuento/100);
                                this.montoTotal=response.data.data.detalles_compras.compras_productos[0].precio-this.montoTotal;

                            }
                            if(this.compra.tipo_descuento=="monto"){
                                this.montoTotal=response.data.data.detalles_compras.compras_productos[0].precio-this.compra.monto_descuento;
                            }



                        let gmt_descuento="";

                        if(this.id_descuento>0){
                            gmt_descuento=this.descuento.monto+"-"+this.compra.tipo_descuento
                        }


                        if (
                            (this.estado_compra == "PAGADA" ||
                                this.estado_compra == "PAGADA_SUSCRITO" ||
                                this.estado_compra == "PROCESANDO") &&
                            this.$route.params.estado != "aprobado"
                        ) {
                            this.$router.push({
                                name: "error404"
                            });
                        }
                        if (
                            (this.estado_compra == "RECHAZADA"  || this.estado_compra == "PENDIENTE_PAGO"  || this.estado_compra == "ERROR"  ) &&
                            this.$route.params.estado != "rechazada"
                        ) {
                            this.$router.push({
                                name: "error404"
                            });
                        }

                        if (this.estado_compra == "PAGADA" || this.estado_compra == "PROCESANDO" || this.estado_compra == "PAGADA_SUSCRITO"){
                            //ACTIVAR COMPRA FINALIZADA
                            dataLayer.push({
                                'event':"transaction",
                                'ecommerce': {
                                    'purchase': {
                                        'actionField': {
                                            'id': this.compra.id,                         // Transaction ID. Required for purchases and refunds.
                                            'affiliation': this.portal.nombre,
                                            'revenue': (response.data.data.is_movil == 1) ?
                                            response.data.data.precio_movil : this.montoTotal,                     // Total transaction value (incl. tax and shipping)
                                            'tax':'0',
                                        },
                                        'products': [{                            // List of productFieldObjects.
                                            'name': response.data.data.detalles_compras.compras_productos[0].producto,     // Name or ID is required.
                                            'id': response.data.data.detalles_compras.compras_productos[0].id_producto,
                                            'price': (response.data.data.is_movil == 1) ?
                                            response.data.data.precio_movil : response.data.data.detalles_compras.compras_productos[0].precio ,
                                            'category': this.linkCurso.categoria,
                                            'quantity': 1,
                                        }]
                                    }
                                }
                            });
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            
            }

		},
		VerificarCompra(id_compra) {
			this.$api
				.verificar_compra_pendiente(id_compra)
				.then(response => {
					console.log(response.data.response);
					window.location =
						"http://" +
						this.portal.dominio +
						"/" +
						response.data.response;
				})
				.catch(error => {
					console.log("error");
				});
		}
	},
	created() {
		this.DetalleCompra();
	}
};
</script>
